import { ReqParams } from "@/types";
import axiosInstance from "./axiosInstance";


export default class AgentService {
  static async add(params: ReqParams = {}) {
    const response = await axiosInstance.post("/tenant/agents", params);
    return response.data;
  }

  static async getList(params: ReqParams = {}) {
    const response = await axiosInstance.get("/tenant/agents", { params });
    return response.data;
  }

  static async getDetails(params: ReqParams = {}) {
    const response = await axiosInstance.get("/tenant/agents/" + params.id, { params });
    return response.data;
  }

  static async update(params: ReqParams = {}) {
    const response = await axiosInstance.put("/tenant/agents/" + params.id, params);
    return response.data;
  }

  static async getDashboardData(params: ReqParams = {}) {
    const response = await axiosInstance.get(`/agent/dashboard/count?fromDate=${params.startDate}&toDate=${params.endDate}`);
    return response.data;
  }

  static async getChatData(params: ReqParams = {}) {
    const response = await axiosInstance.post(`agent/ai-chat`, params, {
      skipGlobalLoader: true,
    });
    return response.data;
  }

  static async confirmEscalation(params: ReqParams = {}) {
    const response = await axiosInstance.post(`agent/ai-chat/confirm-escalation`, params, {
      skipGlobalLoader: true,
    });
    return response.data;
  }
  static async AddCustomer(params: ReqParams = {}) {
    const response = await axiosInstance.post(`crm/tenant/create-customer`, params);
    return response.data;
  }

  static async editCustomer(params: ReqParams = {}, id: number) {
    const response = await axiosInstance.patch(`crm/agent/customer-update-request/${id}`, params);
    return response.data;
  }

  static async getCustomerList(params: ReqParams = {}) {
    const response = await axiosInstance.get(`crm/agent/customer-list`, { params });
    return response.data;
  }

  static async getCustomerData(params: ReqParams = {}) {
    const response = await axiosInstance.get(`crm/agent/view-customer/${params.id}`);
    return response.data;
  }


  /**
  * Fetch attendance list for a specific agent
  * @param params { agentId, page, limit, status, startDate, endDate }
  */
  static async getAttendanceList(params: ReqParams = {}) {
    const { agentId, ...query } = params as any;
    const response = await axiosInstance.get(`/tenant/agents/attendance/${agentId}`, { params: query });
    return response.data;
  }

  /**
   * Add / update manual attendance for an agent
   * Body: { agentId, attendanceDate (YYYY-MM-DD), reason, status, totalHours }
   */
  static async addManualAttendance(params: ReqParams = {}) {
    const response = await axiosInstance.post(`/tenant/agents/add-manual-attendance`, params);
    return response.data;
  }

  static async punchIn(params: ReqParams = {}) {
    const response = await axiosInstance.post(`/tenant/agents/punch-in`, params, {
      skipGlobalLoader: true,
    });
    return response.data;
  }

  static async punchOut(params: ReqParams = {}) {
    const response = await axiosInstance.post(`/tenant/agents/punch-out`, params, {
      skipGlobalLoader: true,
    });
    return response.data;
  }

  static async getLeadsList(params: ReqParams = {}) {
    const response = await axiosInstance.get(`sales/leads/list`, { params });
    return response.data;
  }

  static async addLeads(params: ReqParams = {}) {
    const response = await axiosInstance.post(`sales/leads/create`, params);
    return response.data;
  }

  static async editLeads(params: ReqParams = {}, id: number) {
    const response = await axiosInstance.put(`sales/leads/${id}`, params);
    return response.data;
  }

  static async getSalesList(params: ReqParams = {}) {
    const response = await axiosInstance.get(`sales/deals/v2/list`, { params });
    return response.data;
  }

  static async getSalesPersonList() {
    const response = await axiosInstance.get(`sales/deals/sales-person-List`);
    return response.data;
  }

  static async addDeal(params: ReqParams = {}) {
    const response = await axiosInstance.post(`sales/deals/create`, params);
    return response.data;
  }

  static async editDeal(params: ReqParams = {}, id: number) {
    const response = await axiosInstance.put(`sales/deals/edit/${id}`, params);
    return response.data;
  }

  static async getDealData(id: number) {
    const response = await axiosInstance.get(`sales/deals/view/${id}`);
    return response.data;
  }

  static async getSlaesDealCount() {
    const response = await axiosInstance.get(`sales/deals/counts`);
    return response.data;
  }

  static async getContactPersonData(params: ReqParams = {}) {
    const response = await axiosInstance.get(`sales/deals/tenant-customer-search`, { params });
    return response.data;
  }

  static async getDealConversations(id: number) {
    const response = await axiosInstance.get(`sales/deals/conversation-details/${id}`);
    return response.data;
  }

  static async sendEmailForDealConversations(params: ReqParams | FormData = {}) {
    const response = await axiosInstance.post(`sales/deals/tenant-send-conversation-email`, params, {
      skipGlobalLoader: true,
    });
    return response.data;
  }

  static async getPreviousDealData(id: number) {
    const response = await axiosInstance.get(`sales/lead-previous-deals-query/${id}`);
    return response.data;
  }

  static async escalateTicket(params: FormData) {
    const response = await axiosInstance.post(`agent/ticket/escalate`, params, {
      skipGlobalLoader: true,
    });
    return response.data;
  }

  static async assignShiftList() {
    const response = await axiosInstance.get(`/tenant/assign-shifts-list`);
    return response.data;
  }

  static async shiftAgents() {
    const response = await axiosInstance.get(`/tenant/agent-list-for-shift-swap`);
    return response.data;
  }

  static async myAssignShifts(id: number) {
    const response = await axiosInstance.get(`/tenant/assign-shifts-list-no-pagination/${id}`);
    return response.data;
  }

  static async swapRequest(params: ReqParams = {}) {
    const response = await axiosInstance.post(`/tenant/agent/shift-swap-request`, params);
    return response.data;
  }

  static async getSwapRequests(params: ReqParams = {}) {
    const response = await axiosInstance.get(`/tenant/shift-swap-request-list`, { params });
    return response.data;
  }
  //dashboard grpahs
  static async getPipeLineByStage(params: ReqParams = {}) {
    const response = await axiosInstance.get(`/sales/reports/pipeline-by-stage`, { params });
    return response.data;
  }
  static async getPipeLineStageValue(params: ReqParams = {}) {
    const response = await axiosInstance.get(`/sales/reports/pipeline-value-by-Stage`, { params });
    return response.data;
  }

  static async getTargetShifts(date: string, agentId: number) {
    const response = await axiosInstance.get(`/tenant/api-for-shift-swap-view?requesterAgentId=${agentId}&fromDate=${date}&toDate=${date}`);
    return response.data;
  }

  static async getTargetAgents(date: string, shiftId: number) {
    const response = await axiosInstance.get(`/tenant/api-for-shift-swap-view?targetShiftTypeId=${shiftId}&fromDate=${date}&toDate=${date}`);
    return response.data;
  }

  static async getStats(params: ReqParams = {}) {
    const response = await axiosInstance.get(`/sales/reports/KPI-summary`, { params });
    return response.data;
  }

  static async getPipeLineBySalesOwner(params: ReqParams = {}) {
    const response = await axiosInstance.get(`/sales/reports/pipeline-by-owner`, { params });
    return response.data;
  }

  static async getDealAging(params: ReqParams = {}) {
    const response = await axiosInstance.get(`/sales/reports/deal-aging-analysis`, { params });
    return response.data;
  }

  static async getForecastVsTarget(params: ReqParams = {}) {
    const response = await axiosInstance.get(`/sales/reports/forecast-vs-target`, { params });
    return response.data;
  }

  static async getTrendAnalysis(params: ReqParams = {}) {
    const response = await axiosInstance.get(`/sales/reports/deal-monthly-trend-analysis`, { params });
    return response.data;
  }

  static async createLeaveRequest(params: ReqParams = {}) {
    const response = await axiosInstance.post(`/tenant/agent/leave-request`, params);
    return response.data;
  }

  static async getLeaveRequests(params: ReqParams = {}) {
    const response = await axiosInstance.get(`/tenant/leave-request-list`, { params });
    return response.data;
  }

  static async getFacebookPostThreads(params: ReqParams = {}) {
    const response = await axiosInstance.get(`/facebook-messenger/facebook-post-threads`, { params });
    return response.data;
  }

  static async getFacebookPostThreadComments(threadId: number | string, params: ReqParams = {}) {
    const response = await axiosInstance.get(`/facebook-messenger/facebook-post-threads/${threadId}/comments`, { params });
    return response.data;
  }

  static async replyToFacebookComment(commentId: string, message: string) {
    const response = await axiosInstance.post(`/facebook-messenger/facebook-comment/${commentId}/reply`, { message }, {
      skipGlobalLoader: true,
    });
    return response.data;
  }

  static async privateReplyToFacebookComment(commentId: string, message: string) {
    const response = await axiosInstance.post(`/facebook-messenger/facebook-comment/${commentId}/private-reply`, { message }, {
      skipGlobalLoader: true,
    });
    return response.data;
  }

  static async updateProfile(params: ReqParams = {}) {
    const response = await axiosInstance.patch("/agent/update-profile", params);
    return response.data;
  }

  static async getInstagramPostThreads(params: ReqParams = {}) {
    const response = await axiosInstance.get(`/instagram-messenger/instagram-post-threads`, { params });
    return response.data;
  }

  static async getInstagramPostThreadComments(threadId: number | string, params: ReqParams = {}) {
    const response = await axiosInstance.get(`/instagram-messenger/instagram-post-threads/${threadId}/comments`, { params });
    return response.data;
  }

  static async replyToInstagramComment(commentId: string, message: string) {
    const response = await axiosInstance.post(`/instagram-messenger/instagram-comment/${commentId}/reply`, { message }, {
      skipGlobalLoader: true,
    });
    return response.data;
  }

  static async privateReplyToInstagramComment(commentId: string, message: string) {
    const response = await axiosInstance.post(`/instagram-messenger/instagram-comment/${commentId}/private-reply`, { message }, {
      skipGlobalLoader: true,
    });
    return response.data;
  }

  static async metaOauthLogin(tenantId: number, service: 'facebook' | 'instagram') {
    const response = await axiosInstance.get(`/meta/login`, { params: { tenantId, service } });
    return response.data;
  }
}
